import React from "react";
import { ExpandableSection, Badge, Box, Header } from "@cloudscape-design/components";
import { JsonViewer } from "../common";
import { CustomerData, CustomerDataHistory } from "../../services";
import { TableName, LABELS } from "../../constants";
import { HistoryView } from "./HistoryView";

interface DataTabProps {
  table: TableName;
  data: CustomerData;
  history: CustomerDataHistory | null;
}

export const DataTab: React.FC<DataTabProps> = ({ table, data, history }) => {
  const tableData = data[table];
  const tableHistory = history?.[table] || [];
  const hasHistory = tableHistory.length > 0;

  return (
    <Box>
      <Box margin={{ bottom: "l" }}>
        <Header variant="h3">{LABELS.CURRENT_DATA}</Header>
        <JsonViewer data={tableData} />
      </Box>

      {hasHistory && (
        <ExpandableSection
          variant="container"
          headerText={
            <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
              {LABELS.VERSION_HISTORY}
              <Badge color="blue">{tableHistory.length}</Badge>
            </span>
          }
        >
          <HistoryView current={tableData} history={tableHistory} />
        </ExpandableSection>
      )}
    </Box>
  );
};
